<ins-select
    [(ngModel)]="language"
    (insSelect)="onSelect()">
    <span slot="content">
        <p class="label">{{ label }}:</p>
        <img class="country-flag" [src]="getImageSrc(language.icon)" [alt]="language.country"/>
        <p class="language-name">{{ language.label }}</p>
    </span>
    @for (item of languages; track item) {
        <ins-option
            [value]="item">
            <img class="country-flag" [src]="getImageSrc(item.icon)" [alt]="item.country"/>
            <span>{{item.label}}</span>
            <p class="language-symbol">[{{ item.symbol }}]</p>
        </ins-option>
    }
</ins-select>